export type RequestArgs = {
  path: string;
  auth?: string;
};

export type PostRequestArgs = RequestArgs & {
  body?: any;
  formData?: FormData;
};

function doRequest(method: string, { path, auth, body, formData }: PostRequestArgs) {
  const headers: HeadersInit = {
    authorization: auth ? `Bearer ${auth}` : '',
  };

  if (body) {
    headers['Content-Type'] = 'application/json';
  }

  return fetch(`${process.env.REACT_APP_ADMIN_API_URL}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : formData,
  });
}

const adminApi = {
  get: (args: RequestArgs) => doRequest('GET', args),
  post: (args: PostRequestArgs) => doRequest('POST', args),
  put: (args: PostRequestArgs) => doRequest('PUT', args),
  delete: (args: PostRequestArgs) => doRequest('DELETE', args),
};

export default adminApi;
